export const MATCHING_EMAIL_PREFERENCES = {
  SUCCESS: 'You have successfully updated the email preferences.',
  FAILED: 'Failed to to update. Please try again.',
};
